import { useVectorCapitalSimulator } from '../VectorCapitalSimulatorContext';

export default function VcCalendarWidget() {
  const sim = useVectorCapitalSimulator();
  return sim.renderCalendar();
}
